<template>
  <div class="habilitados">
    <div class="row">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-primary btn-voltar"
          @click="$router.back()"
        >
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <h2 class="page-header">Pré-habilitados</h2>
        <h3>
          Edital nº {{ edital.numero }} - Processo nº
          {{ edital.processo_numero }}
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <data-table
          ref="vuetable"
          :title="'Lista de Cargos'"
          :dados="cargos"
          :fields="fields"
          :carregando="loading.data"
        >
        </data-table>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <h3 id="cabecalho_habilitados">Importar Pré-habilitados</h3>
      </div>
      <div class="col-xs-12 form-group">
        <button role="button" class="btn btn-default" @click="urlArquivoBase()">
          <font-awesome-icon :icon="'file-download'" />
          Baixar arquivo base
        </button>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <label class="" for="input-file-import">Upload CSV Habilitados</label>
          <input
            type="file"
            class="form-control"
            :class="{ ' is-invalid': error.message }"
            id="input-file-import"
            name="file_import"
            accept=".csv"
            ref="import_file"
            @change="onFileChange"
          />
        </div>
        <div v-if="error.message" class="invalid-feedback"></div>
        <div class="form-group">
          <button
            class="btn btn-default"
            @click="proceedAction"
            :disabled="!this.import_file || loading.file"
          >
            <font-awesome-icon v-if="loading.file" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'save'" />
            Enviar
          </button>
        </div>
      </div>
      <div class="col-xs-12">
        <pre-habilitado-table
          ref="vuetable_habilitados"
          id="vuetable_habilitados"
          :title="'Lista de Pré-Habilitados'"
          :data="habilitados"
          :carregando="loading.data"
        >
        </pre-habilitado-table>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/request'
import { NoApiTable, PreHabilitadoTable } from '@/components'

export default {
  components: { DataTable: NoApiTable, PreHabilitadoTable },
  data() {
    return {
      error: {},
      import_file: '',
      loading: {
        file: false,
        data: false
      },
      edital: {},
      cargos: [],
      habilitados: [],
      fields: [
        {
          name: 'descricao',
          title: 'Descrição'
        },
        {
          name: 'vagas',
          title: 'Vagas',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: 'vagas_pcd',
          title: 'Vagas PCD',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: 'vagas_cotas',
          title: 'Vagas Cotas',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: 'vagas_QP',
          title: 'Vagas QP',
          titleClass: 'text-right',
          dataClass: 'text-right'
        }
      ],
      fieldsPreHabilitados: [
        {
          name: 'classificacao',
          title: 'Classificação',
          dataClass: 'text-center'
        },
        {
          name: 'inscricao',
          title: 'Inscrição'
        },
        {
          name: 'cargo.descricao',
          title: 'Cargo'
        },
        {
          name: 'nome',
          title: 'Nome'
        },
        {
          name: 'negro',
          title: 'Negro',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'deficiente',
          title: 'Deficiente',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'avaliacao_status',
          title: 'Status'
        },
        {
          name: 'data_avaliacao',
          title: 'Data Avaliação'
        },
        {
          name: '__slot:actions',
          title: 'Excluir',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ]
    }
  },
  created() {
    if (_.isEmpty(this.$route.params)) {
      this.$router.push({ name: 'editais' })
    } else {
      this.edital = { ...this.$route.params.edital }
      this.listarCargosEdital()
      this.listarHabilitadosEdital()
    }
  },
  methods: {
    urlArquivoBase() {
      request
        .get('prehabilitado/download-planilha-base', {
          responseType: 'arraybuffer'
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/csv' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'pre-habilitados-base.csv'
          link.click()
        })
    },
    excluir(props) {
      const { id, geral, pcd, cotas } = props
      const config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`prehabilitados/${id}`, {
              params: { geral, pcd, cotas, edital_id: this.edital.id }
            })
            .then(response => {
              this.$toastr.s('Candidato habilitado excluído com sucesso')
              this.listarHabilitadosEdital()
            })
            .catch(error => {
              this.$toastr.e(
                'Houve um erro ao excluir o candidato habilitado, tente novamente e, se persistir o erro, entre em contato com o administrador.'
              )
            })
        }
      }
      this.showConfirm(
        'Deseja realmente excluir este candidato habilitado?',
        config
      )
    },
    onFileChange(e) {
      this.import_file = e.target.files[0]
    },
    proceedAction() {
      if (!this.import_file) {
        this.$toastr.e('Arquivo de importação não encontrado!')
        return
      }
      this.handleLoading('file')

      const cargos = this.cargos.map(({ id, descricao }) => ({ id, descricao }))

      let formData = new FormData()
      formData.append('edital_id', this.edital.id)
      formData.append('cargos', JSON.stringify(cargos))
      formData.append('import_file', this.import_file)

      request
        .post('/prehabilitados', formData, {
          headers: { 'content-type': 'multipart/form-data' }
        })
        .then(response => {
          const { msg } = response.data
          this.$toastr.s(msg)
          this.listarHabilitadosEdital()
        })
        .catch(error => {
          const { data } = error.response
          this.$toastr.e(data.msg)
          this.error = error.response.data
          console.log('check error: ', this.error)
        })
        .finally(this.handleLoading('file'))
    },
    scrollToElement(refName) {
      let element = document.getElementById(refName)
      element.scrollIntoView({ behavior: 'smooth' })
    },
    listarCargosEdital() {
      request
        .get('cargo', { params: { nr_edital: this.edital.numero } })
        .then(response => {
          const { data } = response
          this.cargos = data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    filter: key => item => item[key] === 1,
    listarHabilitadosEdital() {
      this.handleLoading('data')
      request
        .get('prehabilitados', { params: { edital_id: this.edital.id } })
        .then(response => {
          this.habilitados = response.data
        })
        .catch(error => console.log(error.response))
        .finally(this.handleLoading('data'))
    },
    handleLoading(action) {
      this.loading[action] = !this.loading[action]
    }
  }
}
</script>

<style scoped>
.btn-voltar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/concursos/edital/PreHabilitados.vue